import {
    CREATE_SEND_BOOTCAMP_SUBSCRIPTION_REQUEST,
    CREATE_SEND_BOOTCAMP_SUBSCRIPTION_SUCCESS,
    CREATE_SEND_BOOTCAMP_SUBSCRIPTION_FAILURE,

    FETCH_BOOTCAMP_SUBSCRIPTION_REQUEST,
    FETCH_BOOTCAMP_SUBSCRIPTION_SUCCESS,
    FETCH_BOOTCAMP_SUBSCRIPTION_FAILURE,

    UPDATE_BOOTCAMP_SUBSCRIPTION_REQUEST,
    UPDATE_BOOTCAMP_SUBSCRIPTION_SUCCESS,
    UPDATE_BOOTCAMP_SUBSCRIPTION_FAILURE,
    UPDATE_BOOTCAMP_SUBSCRIPTION_RESET


} from "./BootcampSubscriptionType"

const initialSendRequestBootcampSubscription = {
    res : [],
    loading: false,

}

export const sendRequestBootcampSubscriptionReducer = (state = initialSendRequestBootcampSubscription, action) => {
    switch (action.type) {
        case CREATE_SEND_BOOTCAMP_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                loading: true
            }
        case CREATE_SEND_BOOTCAMP_SUBSCRIPTION_SUCCESS:
            return {
                loading: false,
                done : true,
                res: [action.payload]
            }
        case CREATE_SEND_BOOTCAMP_SUBSCRIPTION_FAILURE:
            return {
                loading: false,
                res: [],
                done : true,
                error: action.payload
            }
        default: return state;
    }
}

const initialFetchBootcampSubscription = {
    bootcampSubscription : [],
    loading: false,

}

export const fetchRequestBootcampSubscriptionReducer = (state = initialFetchBootcampSubscription, action) => {
    switch (action.type) {
        case FETCH_BOOTCAMP_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_BOOTCAMP_SUBSCRIPTION_SUCCESS:
            return {
                loading: false,
                bootcampSubscription: action.payload
            }
        case FETCH_BOOTCAMP_SUBSCRIPTION_FAILURE:
            return {
                loading: false,
                bootcampSubscription: [],
                error: action.payload
            }
        default: return state;
    }
}


const initialUpdateBootcampSubscription = {
    bootcampSubscription: [],
    loading : false,
    done: false
}

export const updateBootcampSubscriptionReducer = (state = initialUpdateBootcampSubscription, action) => {
    switch(action.type){
        case UPDATE_BOOTCAMP_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                bootcampSubscription: [],
                done : false
            }
        case UPDATE_BOOTCAMP_SUBSCRIPTION_RESET:
            return {
                ...state,
                loading: true
            }
        case UPDATE_BOOTCAMP_SUBSCRIPTION_SUCCESS:
            return {
                loading: false,
                done : true,
                bootcampSubscription: [action.payload]
            }
        case UPDATE_BOOTCAMP_SUBSCRIPTION_FAILURE:
            return {
                loading : false,
                bootcampSubscription : [],
                done : true,
                error: action.payload
            }
        default: return state;
    }
}